import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function OperatePhaseIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8238_13613)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2432 5.42074C11.6214 5.45907 11.917 5.77845 11.917 6.16683C11.9169 6.55514 11.6214 6.87461 11.2432 6.91292L11.167 6.91683H5.98145C5.48743 6.91693 5.25 7.25196 5.25 7.4764V15.4168H7.38672C7.85026 15.4169 8.28633 15.6197 8.58496 15.9647L8.7041 16.1209L8.70508 16.1219L9.04395 16.6287L9.07324 16.6561C9.08502 16.6623 9.09924 16.6659 9.11328 16.6659H13.2207C13.249 16.6657 13.2756 16.6514 13.29 16.6297L13.6289 16.1219L13.748 15.9647C14.047 15.6187 14.4843 15.4168 14.9463 15.4168H17.084V12.8328C17.0842 12.4189 17.4199 12.0828 17.834 12.0828C18.2477 12.0832 18.5837 12.4191 18.584 12.8328V15.6063C19.0794 15.8739 19.4169 16.3975 19.417 16.9998V17.8338C19.4167 19.1685 18.3347 20.2497 17 20.2498H5.33398C3.9991 20.2498 2.91726 19.1686 2.91699 17.8338V16.9998C2.91711 16.3971 3.25401 15.8727 3.75 15.6053V7.4764C3.75 6.25429 4.83903 5.41694 5.98145 5.41683H11.167L11.2432 5.42074ZM4.5 16.9168C4.45447 16.917 4.41717 16.9543 4.41699 16.9998V17.8338C4.41726 18.3402 4.82753 18.7498 5.33398 18.7498H17C17.5063 18.7497 17.9167 18.3401 17.917 17.8338V16.9998C17.9169 16.9659 17.8957 16.9365 17.8662 16.9237L17.834 16.9168H14.9463C14.9179 16.9168 14.8915 16.9312 14.877 16.953L14.5381 17.4598L14.5391 17.4608C14.2453 17.9022 13.7488 18.1657 13.2207 18.1659H9.11328C8.58515 18.1659 8.08876 17.9021 7.79492 17.4608L7.45801 16.9549L7.42676 16.9266C7.4148 16.9203 7.40072 16.9169 7.38672 16.9168H4.5Z"
          fill="currentColor"
        />
        <path
          d="M7.93555 11.9832L7.93848 11.9842C8.37256 12.0247 8.71289 12.3892 8.71289 12.8338C8.71262 13.2973 8.3386 13.6872 7.85938 13.6873C7.38787 13.6873 7.00515 13.3053 7.00488 12.8338C7.00376 12.3843 7.34877 12.0246 7.77832 11.9842C7.80456 11.9814 7.83142 11.9793 7.8584 11.9793L7.93555 11.9832Z"
          fill="currentColor"
        />
        <path
          d="M14.5762 12.0877C14.9544 12.1261 15.25 12.4454 15.25 12.8338C15.2497 13.222 14.9543 13.5416 14.5762 13.5799L14.5 13.5838H10.333C9.91911 13.5836 9.58328 13.2477 9.58301 12.8338C9.58301 12.4197 9.91894 12.084 10.333 12.0838H14.5L14.5762 12.0877Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1338 4.65706C15.474 3.44729 17.5192 3.44735 18.8594 4.65706L18.9912 4.78207L19.002 4.79378C20.1904 5.99255 20.3417 7.83043 19.458 9.1932L20.8701 10.6434L20.9209 10.701C21.1574 10.9986 21.1345 11.4329 20.8564 11.7039C20.5782 11.9746 20.1428 11.9871 19.8516 11.743L19.7959 11.6903L18.3936 10.2508C17.0284 11.1236 15.1949 10.9643 14.002 9.77132C12.6246 8.3935 12.6245 6.16081 14.002 4.78304L14.1338 4.65706ZM17.7764 5.70394C17.033 5.09849 15.9601 5.09843 15.2168 5.70394L15.0625 5.84359C14.2709 6.63557 14.2709 7.91874 15.0625 8.71078C15.8532 9.50148 17.1333 9.50257 17.9258 8.71468C17.9289 8.71158 17.9314 8.70798 17.9346 8.70492C17.9361 8.70342 17.9379 8.70151 17.9395 8.70003C18.6725 7.95678 18.7165 6.78988 18.0693 5.99691L17.9307 5.84359L17.7764 5.70394Z"
          fill="currentColor"
        />
        <path
          d="M7.94434 8.64925C8.37268 8.69267 8.71167 9.05425 8.71191 9.49984C8.71174 9.9713 8.32986 10.3532 7.8584 10.3534C7.39017 10.3532 7.0103 9.97658 7.00488 9.5096L7.00391 9.51058C6.99758 9.05695 7.34344 8.69175 7.77539 8.65023C7.80221 8.64732 7.82983 8.64536 7.85742 8.64535L7.94434 8.64925Z"
          fill="currentColor"
        />
        <path
          d="M11.2432 8.75374C11.6211 8.79222 11.9158 9.11179 11.916 9.49984C11.9159 9.88798 11.6212 10.2075 11.2432 10.2459L11.166 10.2498H10.333C9.91905 10.2497 9.58318 9.91379 9.58301 9.49984C9.58326 9.08595 9.9191 8.75001 10.333 8.74984H11.166L11.2432 8.75374Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_8238_13613">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
